const STAGE_VALUE_ALIASES: Record<string, string> = {
  'col-lost': 'lost1',
};

const DEFAULT_STAGE_THEME = {
  background: '#FFF3DC',
  border: '#F5A623',
  text: '#E8920A',
};

const STAGE_THEMES: Record<string, { background: string; border: string; text: string }> = {
  'col-lost': { background: '#FFEBEE', border: '#F44336', text: '#B71C1C' },
  'col-lead': { background: '#FFF3E0', border: '#FF9800', text: '#E65100' },
  'col-anketa': { background: '#E3F2FD', border: '#2196F3', text: '#0D47A1' },
  'col-review': { background: '#F3E5F5', border: '#9C27B0', text: '#6A1B9A' },
  'col-wait': { background: '#FFF3DC', border: '#F5A623', text: '#E65100' },
  'col-ticket': { background: '#E0F2F1', border: '#009688', text: '#004D40' },
  'col-send': { background: '#E8F5E9', border: '#4CAF50', text: '#1B5E20' },
  'col-sign': { background: '#FFF8E1', border: '#FFC107', text: '#F57F17' },
  'col-done': { background: '#F5F5F5', border: '#4CAF50', text: '#388E3C' },
};

export function getBoardColumnClass(colName: string): string {
  return colName.startsWith('col-') ? colName : `col-${colName}`;
}

export function getBoardStageValue(colName: string): string {
  const columnClass = getBoardColumnClass(colName);
  return STAGE_VALUE_ALIASES[columnClass] ?? columnClass.replace(/^col-/, '');
}

export function getBoardStageTheme(colName?: string) {
  if (!colName) {
    return DEFAULT_STAGE_THEME;
  }

  return STAGE_THEMES[getBoardColumnClass(colName)] ?? DEFAULT_STAGE_THEME;
}

export function getThemeFromStage(stage: {
  colors?: { headerBg?: string; dotBg?: string; nameColor?: string } | null;
}) {
  if (stage.colors?.headerBg) {
    return {
      background: stage.colors.headerBg,
      border: stage.colors.dotBg ?? stage.colors.headerBg,
      text: stage.colors.nameColor ?? DEFAULT_STAGE_THEME.text,
    };
  }
  return DEFAULT_STAGE_THEME;
}

export const CALL_STATUSES = [
  { id: 'new',      label: 'Новый',       cls: 'csb-new',      stcls: 'st-new' },
  { id: 'callback', label: 'Перезвонить', cls: 'csb-callback', stcls: 'st-callback' },
  { id: 'noanswer', label: 'Нет ответа',  cls: 'csb-noanswer', stcls: 'st-noanswer' },
  { id: 'inwork',   label: 'В работе',    cls: 'csb-inwork',   stcls: 'st-inwork' },
  { id: 'done',     label: 'Завершён',    cls: 'csb-done',     stcls: 'st-done' },
];

export const MGR_COLORS = ['#F5A623','#2196F3','#4CAF50','#9C27B0','#FF5722','#009688'];
